module.exports = {"id":"177621","name":"Carlos Felipe Rodríguez","rating":"72","photo":"./data/images/photos/4/177621.png","club":{"name":"León","logo":"./data/images/clubs/Leon.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosFelipeRodriguez0.json
// module id = 716
// module chunks = 0